import {  ModalButton, ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalButtonType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';

export class BarcodeUtils {
  static dialogModalConfirm(barcodeValue: string, action: CallableFunction): void {
    const buttons: ModalButton[] = [];

    buttons.push({
      action: () => { },
      title: 'tws.biometry.cancel',
      type: ModalButtonType.CANCEL,
    });

    buttons.push({
      action: () => action(barcodeValue),
      title: 'tws.file-uploader-modal.confirm',
      type: ModalButtonType.SUCCESS,
    });

    const dialogModal: ModalProps = {
      closeable: true,
      closeByDocument: false,
      closeByEscape: false,
      dialogDescription: MessageService.translate('text.undo-medication-reading'),
      dockButtons: buttons,
      focusOnOpen: true,
      title: 'text.message-alert-attention',
      uuid: generateUUID(),
    };

    ModalService.openDialog(dialogModal);
  }
}
